module.exports = __webpack_public_path__ + "img/表情.1ba70dd7.png";